import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import AboutMe from '../components/AboutMe';
import MasonryGrid from '../components/MasonryGrid';
import MobilePortfolio from '../components/mobile/MobilePortfolio';
import { portfolioItems } from '../data/portfolioData';
const Home = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.matchMedia('(max-width: 768px)').matches);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  if (isMobile) {
    return <MobilePortfolio items={portfolioItems} data-id="element-263" />;
  }
  return <motion.div className="space-y-32" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-264">
      <MasonryGrid items={portfolioItems} data-id="element-265" />
      <AboutMe data-id="element-266" />
    </motion.div>;
};
export default Home;